import React, { useEffect } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AlertDialog } from '@lyearn/molecules';

interface DeleteModalProps {
  title: string;
  description: string;
  onClose: () => void;
  onDelete: () => void;
  isSubmitting: boolean;
  open: boolean;
}

function DeleteModal({
  title,
  description,
  onClose,
  onDelete,
  isSubmitting,
  open,
}: DeleteModalProps) {
  const { t } = useTranslation(['Common']);

  useEffect(() => {
    // trigger onDelete on Enter key press if open

    const handleKeyDown = (event: KeyboardEvent) => {
      if (open && event.key === 'Enter') {
        onDelete();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);

  return (
    <AlertDialog
      header={{
        title,
        description,
      }}
      open={open}
      primaryAction={{
        appearance: 'danger',
        label: t('Common:Actions.Delete'),
        onClick: onDelete,
        loading: isSubmitting,
      }}
      onClose={onClose}
    />
  );
}

export default DeleteModal;
